// extracted by mini-css-extract-plugin
module.exports = {"staff":"StaffAvatarStyle_staff__11xlH","img_box":"StaffAvatarStyle_img_box__17SHk","name":"StaffAvatarStyle_name__1aTEz","rating":"StaffAvatarStyle_rating__16x5R"};